/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-function */
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Button, Group, Modal, Space } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import filesize from 'filesize';
import { EntityDocumentFileType, EntityDocumentType } from '../../../../../../../models/core/entities.type';
import DocumentFileFormAddEdit from './DocumentFileFormAddEdit';
import DocumentFileFormViewActions from './DocumentFileFormViewActions';
import { newGuid } from '../../../../../../../utils/helper.utils';
import { Feature } from '../../../../../../../utils/constants.utils';
import PageSection from '../../../../../../../components/core/PageSection/PageSection';
import { Action } from '../../../../../../../models/core/core.type';

type FormViewProps = {
  entityDocument: (EntityDocumentType & { origFiles?: EntityDocumentFileType[] }) | null;
  zIndex: number;
};

const DocumentFileFormView = forwardRef((props: FormViewProps, ref) => {
  const [data, setData] = useState<EntityDocumentFileType[]>(
    props.entityDocument?.arquivos.map((x) => {
      return {
        ...x,
        action: x.action || Action.Nothing,
        id: x.idEntidadeDocumentoArquivo?.toString() || x.idTemporaria || newGuid(),
      };
    }) || []
  );
  const [opened, setOpened] = useState(false);

  const columns: ColumnsType<any> = [
    {
      title: 'Nome',
      key: 'nome',
      dataIndex: 'nome',
      sorter: (a: EntityDocumentFileType, b: EntityDocumentFileType) => a.nome.localeCompare(b.nome),
    },
    {
      title: 'Tamanho',
      key: 'tamanho',
      sorter: (a: EntityDocumentFileType, b: EntityDocumentFileType) => {
        const aValue = a.tamanho;
        const bValue = b.tamanho;
        if (aValue === bValue) {
          return 0;
        }
        return aValue > bValue ? 1 : -1;
      },
      render: (row: EntityDocumentFileType) => <div>{filesize(row.tamanho, { locale: 'pt-BR' })}</div>,
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row: EntityDocumentFileType) => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        <DocumentFileFormViewActions
          item={row}
          confirmActionResult={confirmActionResult}
          zIndex={props.zIndex + 1}
        />
      ),
    },
  ];

  const confirmActionResult = (
    items: EntityDocumentFileType[] | null,
    action: string,
    confirmed: boolean
  ) => {
    if (!confirmed) {
      return;
    }

    let dataItemIndex;
    let dataItem;

    switch (action) {
      case 'excluir':
        dataItemIndex = data.findIndex((x) => x.id === items![0].id);
        if (dataItemIndex > -1) {
          dataItem = data[dataItemIndex];
          if (dataItem.idEntidadeDocumentoArquivo) {
            data[dataItemIndex] = { ...dataItem, action: Action.Delete };
          } else {
            data.splice(dataItemIndex, 1);
          }
          setData(JSON.parse(JSON.stringify(data)));
        }
        break;
      case 'adicionar':
        setOpened(true);
        break;
      case 'callback':
        setOpened(false);
        setData(data.concat(items || []));
        break;
      default:
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    validate(): EntityDocumentFileType[] {
      return data;
    },
    clear() {
      setData([]);
    },
  }));

  return (
    <div>
      <Modal
        opened={opened}
        closeOnClickOutside={false}
        closeOnEscape={false}
        onClose={() => setOpened(false)}
        title="Documento/Arquivo - Adicionar"
        size="xl"
        zIndex={props.zIndex + 1}
      >
        <DocumentFileFormAddEdit
          items={data}
          idEntidadeDocumento={props.entityDocument?.idEntidadeDocumento}
          callback={confirmActionResult}
        />
      </Modal>
      <Group justify="space-between">
        <PageSection size="lg" color={Feature.Reference.Entity.color} label="Arquivos" text="" />
        <Button
          color="primary"
          leftSection={<IconPlus size={18} />}
          onClick={() => {
            confirmActionResult(null, 'adicionar', true);
          }}
        >
          Adicionar
        </Button>
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        dataSource={data.filter((x) => x.action !== Action.Delete)}
        columns={columns}
        rowKey={(item: EntityDocumentFileType) => item.id || 0}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
});

export default DocumentFileFormView;
